import React, { useState } from "react";
import { createCouponService, getBarcodeList, getProductList, updatePackingListproductid } from "../../../services/apiService";
import { Button, Form, Space, Switch, Row, Col, Card } from 'antd';
import { FaEdit, FaPlus } from "react-icons/fa";
import { Modal, Input, Checkbox } from "antd";


const Barcode = () => {
  const [modelno, setmodelno] = useState("");
  const [list, setlist] = useState([])
  const [Barcodelist, setBarcodelist] = useState([])
  const [disabled, setDisabled] = useState(true);
  const [isBarcodeModalOpen, setIsBarcodeModalOpen] = useState(false);
  const [isBarcodelistOpen, setIsBarcodelistOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [qty, setQty] = useState("");
  const [barcode, setBarcode] = useState("");
  const [form] = Form.useForm();

  const toggle = () => {
    setDisabled(!disabled);
  };

  const onFinish = (values) => {
    console.log("Updated Values:", values.barcodes);
  };
  const productList = async () => {
    try {
      const response = await getProductList(modelno);
      console.log("API Response:", response.data[0].Spares);
      setlist(response.data[0]?.Spares)
    } catch (error) {
      console.error("API Error:", error?.message || error);
      // Optionally show a toast or revert UI
    }
  };
  const BarcodeList = async (id) => {
    try {
      const response = await getBarcodeList(id);

      const data = response.data || [];

      setBarcodelist(data);

      // ✅ IMPORTANT: update form values manually
      form.setFieldsValue({
        barcodes: data,
      });

      setIsBarcodelistOpen(true);

    } catch (error) {
      console.error("API Error:", error?.message || error);
    }
  };

  const updateProductidqty = async (productid, barcode, qty) => {
    try {
      const response = await updatePackingListproductid([{ productid: productid, barcode: barcode, qty: qty }]);
      console.log("API Response:", response.data[0].Spares);
      setlist(response.data[0]?.Spares)
    } catch (error) {
      console.error("API Error:", error?.message || error);
      // Optionally show a toast or revert UI
    }
  };
  return (
    <div style={{ padding: "20px" }}>
      <h5>Model Number</h5>
      <input
        className="top-input"
        placeholder="Enter S.No"
        value={modelno}
        onChange={(e) => setmodelno(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            productList(modelno);
          }
        }}
      />
      <div className="scan-table-wrapper">
        <table className="scan-table">
          <thead>
            <tr>
              <th>Model.No</th>
              <th>Position</th>
              <th>Part No</th>
              <th>Active</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {list?.map((row, index) => {
              return (
                <tr key={row.productid}>
                  <td>{row.modelno}</td>
                  <td>{row.position}</td>
                  <td>{row.partno}</td>
                  <td>  <Space vertical>
                    <Switch disabled={disabled} defaultChecked />
                  </Space></td>
                  <td><FaPlus size={18} color="#0A5587" style={{ marginRight: 20 }}
                    onClick={() => {
                      setSelectedProductId(row.productid);   // 👈 set clicked row product id
                      setIsBarcodeModalOpen(true);
                    }} />
                    <FaEdit color="#0A5587" size={18}
                      onClick={() =>
                        BarcodeList(row.productid)

                      } /> </td>
                </tr>
              );
            })}

          </tbody>

        </table>

        <Modal
          title="Create Barcode"
          open={isBarcodeModalOpen}
          onCancel={() => setIsBarcodeModalOpen(false)}
          footer={null}
          width={500}
        >
          {/* Product ID//9087654321 */}
          <div style={{ marginBottom: 15 }}>
            <label>Product ID</label>
            <Input value={selectedProductId} disabled />
          </div>

          {/* Qty + Barcode + Remove */}
          <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>

            <div style={{ flex: 1 }}>
              <label>QTY</label>
              <Input
                value={qty}
                onChange={(e) => setQty(e.target.value)}
              />
            </div>

            <div style={{ flex: 2 }}>
              <label>Barcode</label>
              <Input
                value={barcode}
                onChange={(e) => setBarcode(e.target.value)}
              />
            </div>

          </div>


          {/* Add row */}
          <Button type="primary" style={{ marginBottom: 20 }}>
            Add
          </Button>

          {/* Active checkbox */}
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block" }}>Active</label>
            <Checkbox defaultChecked />
          </div>

          {/* Footer buttons */}
          <div style={{ display: "flex", gap: 10 }}>
            <Button
              type="primary"
              onClick={() => {

                if (!qty || !barcode) {
                  message.warning("Enter qty and barcode");
                  return;
                }

                updateProductidqty(selectedProductId, barcode, qty);

                setIsBarcodeModalOpen(false);
                setQty("");
                setBarcode("");

              }}
            >
              Save
            </Button>


            <Button onClick={() => setIsBarcodeModalOpen(false)}>
              Cancel
            </Button>
          </div>
        </Modal>

        <Modal
          title="Create Barcode"
          open={isBarcodelistOpen}
          onCancel={() => setIsBarcodelistOpen(false)}
          footer={null}
          width={500}
        >
          <Card style={{ borderRadius: 10 }}>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
            >
              <Form.List name="barcodes">
                {(fields) => (
                  <>
                    {fields.map(({ key, name }) => (
                      <Row
                        key={key}
                        gutter={16}
                        align="middle"
                        style={{
                          marginBottom: 16,
                          padding: 12,
                          background: "#f5f5f5",
                          borderRadius: 8,
                        }}
                      >
                        {/* ID */}
                        <Col span={6}>
                          <Form.Item label="ID" name={[name, "id"]}>
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        {/* QTY */}
                        <Col span={6}>
                          <Form.Item
                            label="QTY"
                            name={[name, "qty"]}
                            rules={[{ required: true }]}
                          >
                            <Input />
                          </Form.Item>
                        </Col>

                        {/* Barcode */}
                        <Col span={12}>
                          <Form.Item
                            label="Barcode"
                            name={[name, "barcode"]}
                            rules={[{ required: true }]}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                    ))}
                  </>
                )}
              </Form.List>

              {/* Buttons */}
              <Row justify="end" gutter={10}>
                <Col>
                  <Button type="primary" htmlType="submit">
                    Update
                  </Button>
                </Col>
                <Col>
                  <Button danger>Cancel</Button>
                </Col>
              </Row>
            </Form>
          </Card>
        </Modal>
      </div>
    </div>
  );
};

export default Barcode;
